// Standalone per-room Scenes screen (full page). Thin wrapper around the shared
// RoomScenesManager — the same logic + editor also power the inline scenes strip
// on the room's device grid (DesktopShell).

import React from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import RoomScenesManager from './RoomScenesManager';

export default function RoomScenesScreen() {
  const { roomId } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  return (
    <RoomScenesManager
      variant="page"
      roomId={roomId}
      // roomName is sent as `roomName` from the mobile Scenes tab and as `name`
      // from the desktop callers — accept both rather than showing "Room".
      roomName={state?.roomName || state?.name || 'Room'}
      // Scenes are stored under the room's LOCATION owner, so the manager needs
      // to know which location this room belongs to. Callers pass it; without it
      // the manager falls back to the currently selected location.
      locationId={state?.locationId ?? null}
      initialDevices={state?.devices || null}
      onBack={() => navigate(-1)}
    />
  );
}
